



















import Base from "@/views/Base";
import {Component, Prop} from "vue-property-decorator";
import {ElementListItem, Element} from '@/models/Presentation';
import AddSurveyFormModal from '@/views/presentation/components/AddSurveyFormModal.vue';

@Component({
  components: { AddSurveyFormModal}
})
export default class SurveyForm extends Base {
  @Prop({required: true}) count!: number;

  item: Element | null = null;

  editSurvey(item: ElementListItem){
    this.item = item.entity;
    this.$bvModal.show('add-survey-form-modal');
  }

  modalHidden(){
    this.item = null;
  }

}
